<span class="thumbnail-wrapper" [innerHTML]="entity | thumbnail:50:30 | async"></span>
